/*
 * @Author: Kaiser
 * @Date: 2019-06-10 10:02:16
 * @Last Modified by: Kaiser
 * @Last Modified time: 2019-07-09 11:51:03
 */
import mutation from './user_mutation';
import action from './user_action';
import state from './user_state';
import getter from './user_getter';

const app = {
  namespaced: true,
  state,
  getters: getter,
  mutations: mutation,
  actions: action,
};

export default app;
